import React, {
  useEffect,
  useLayoutEffect,
  useContext,
  useRef,
} from "react";

import { ThemeProvider } from "styled-components";
import { Helmet } from "react-helmet";
import AOS from "aos";

import Header from "../../sections/mail/MailHeader";
import Footer from "../../sections/mail/MailFooter";
import ScanHeader from "../../sections/scanning/ScanHeader";
import ScanFooter from "../../sections/scanning/ScanFooter";

import ModalVideo from "../ModalVideo";

import GlobalContext from "../../context/GlobalContext";

import GlobalStyle from "../../utils/globalStyle";

import "../../assets/fonts/fontawesome-5/webfonts/fa-brands-400.ttf";
import "../../assets/fonts/fontawesome-5/webfonts/fa-regular-400.ttf";
import "../../assets/fonts/fontawesome-5/webfonts/fa-solid-900.ttf";
import "../../assets/fonts/typography-font/Circular-Std-Book.ttf";
import "../../assets/fonts/typography-font/CircularStd-Black.ttf";
import "../../assets/fonts/typography-font/CircularStd-BlackItalic.ttf";
import "../../assets/fonts/typography-font/CircularStd-Bold.ttf";
import "../../assets/fonts/typography-font/CircularStd-BoldItalic.ttf";
import "../../assets/fonts/typography-font/CircularStd-Book.ttf";
import "../../assets/fonts/typography-font/CircularStd-BookItalic.ttf";
import "../../assets/fonts/typography-font/CircularStd-Medium.ttf";
import "../../assets/fonts/typography-font/CircularStd-MediumItalic.ttf";

import "../../assets/fonts/icon-font/fonts/avasta.ttf";
import "../../assets/fonts/icon-font/css/style.css";

import "./bootstrap-custom.scss";
import "../../../node_modules/slick-carousel/slick/slick.css";
import "../../../node_modules/slick-carousel/slick/slick-theme.css";
import "../../../node_modules/aos/dist/aos.css";

import "../../assets/fonts/icon-font/css/style.css";
import "../../assets/fonts/typography-font/typo.css";
import "../../assets/fonts/inter/inter.css";
import "../../assets/fonts/fontawesome-5/css/all.css";

import { get, merge } from "lodash";

// the full theme object
import { theme as baseTheme } from "../../utils";

// options for different color modes
const modes = { light: "light", dark: "dark" };

// merge the color mode with the base theme
// to create a new theme object
const getTheme = (mode) =>
  merge({}, baseTheme, {
    colors: get(baseTheme.colors.modes, mode, baseTheme.colors),
  });

const Layout = ({ children, pageContext, path, pathname, location }) => {
  const gContext = useContext(GlobalContext);

  // Document scanning is a separate business from mail scanning and gets its
  // own chrome: its own header, its own nav, its own footer, no Sign up
  // button. Swapping here rather than per page means every page under
  // /document-scanning/ picks it up, including any added later.
  //
  // The flag is set in gatsby-node.js onCreatePage, not read from a path prop
  // here: wrapPageElement passes a different shape in the browser and in SSR,
  // so a path check silently fails during build. pageContext is passed in both.
  const currentPath =
    path || pathname || (location && location.pathname) || "";
  const isScanning = pageContext && pageContext.section === "scanning";

  useLayoutEffect(() => {
    AOS.init();
  }, []);

  // Navbar style based on scroll
  const eleRef = useRef();

  useEffect(() => {
    window.addEventListener(
      "popstate",
      function (event) {
        // The popstate event is fired each time when the current history entry changes.
        // gContext.closeAbout();
        // gContext.closeContact();
        // gContext.toggleOffCanvas();
      },
      false
    );
    window.addEventListener(
      "pushState",
      function (event) {
        // The pushstate event is fired each time when the current history entry changes.
        // gContext.closeAbout();
        // gContext.closeContact();
        // gContext.toggleOffCanvas();
      },
      false
    );
  }, [gContext]);

  if (pageContext.layout === "bare") {
    return (
      <ThemeProvider
        theme={
          gContext.themeDark ? getTheme(modes.dark) : getTheme(modes.light)
        }
      >
        <GlobalStyle />
        <Helmet>
          <html lang="en" />
          <link rel="icon" type="image/png" href="/favicon.ico" />
        </Helmet>
        <div className="site-wrapper overflow-hidden" ref={eleRef}>
          {children}
        </div>

        <ModalVideo />
      </ThemeProvider>
    );
  }

  return (
    <>
      <ThemeProvider
        theme={
          gContext.themeDark ? getTheme(modes.dark) : getTheme(modes.light)
        }
      >
        <GlobalStyle />
        <Helmet>
          <title>HotSnail - Mail Redirection &amp; Parcel Forwarding</title>
          <meta name="title" content="HotSnail - Mail Redirection &amp; Parcel Forwarding" />
          <meta name="description" content="Mail Redirection, Mail Scanning &amp; Parcel forwarding from Australia. " />

          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://www.hotsnail.com.au/" />
          <meta property="og:title" content="HotSnail - Mail Redirection &amp; Parcel Forwarding" />
          <meta property="og:description" content="Mail Redirection, Mail Scanning &amp; Parcel forwarding from Australia. " />
          <meta property="og:image" content="https://www.hotsnail.com.au/hotsnail/img/HotSnailLogo2.png"></meta>

          <link rel="icon" type="image/png" href="/favicon.ico" />
          <html lang="en" />
        </Helmet>
        <div className="site-wrapper overflow-hidden" ref={eleRef}>
          {isScanning ? (
            <ScanHeader current={(pageContext && pageContext.currentPath) || currentPath} />
          ) : (
            <Header isDark={gContext.headerDark} />
          )}
          {children}

          {isScanning ? <ScanFooter /> : <Footer isDark={gContext.footerDark} />}
        </div>

        <ModalVideo />
      </ThemeProvider>
    </>
  );
};

export default Layout;
